// polygon contour as a doubly linked list
export class PolygonNode {
    constructor(point) {
        this.next = null;
        this.prev = null;
        this.ear = false;
        this.point = point;
    }
}
export class Polygon {
    constructor() {
        this.length = 0;
        this.first = null;
        this.last = null;
    }
    add(point) {
        const node = new PolygonNode(point);
        if (!this.length) {
            this.first = this.last = node;
        }
        else {
            this.last.next = node;
            node.prev = this.last;
            this.last = node;
        }
        this.length++;
    }
    remove(node) {
        if (!this.length)
            return;
        if (node === this.first) {
            this.first = this.first.next;
            if (!this.first)
                this.last = null;
            else
                this.first.prev = null;
        }
        else if (node === this.last) {
            this.last = this.last.prev;
            this.last.next = null;
        }
        else {
            node.prev.next = node.next;
            node.next.prev = node.prev;
        }
        node.prev = null;
        node.next = null;
        this.length--;
    }
    insertBefore(point, node) {
        const newNode = new PolygonNode(point);
        newNode.prev = node.prev;
        newNode.next = node;
        if (!node.prev)
            this.first = newNode;
        else
            node.prev.next = newNode;
        node.prev = newNode;
        this.length++;
    }
}
//# sourceMappingURL=polygon.js.map